import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { UntilDestroy } from '@ngneat/until-destroy';
import { MixpanelService } from '../../../../../mixpanel/mixpanel.service';
import { MIXPANEL_EVENTS } from '../../../../../mixpanel/mixpanelEvents.enum';

@UntilDestroy()
@Component({
    selector: 'app-valuation-report-announcement-dialog',
    templateUrl: './valuation-report-announcement-dialog.component.html',
    styleUrls: ['./valuation-report-announcement-dialog.component.scss'],
})
export class ValuationReportAnnouncementDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<ValuationReportAnnouncementDialogComponent, boolean>,
        private matIconRegistry: MatIconRegistry,
        private domSanitizer: DomSanitizer,
        private readonly mixpanelService: MixpanelService,
    ) {
        this.addSvgIcon('interface-delete 1');
        this.addSvgIcon('aumico-pattern-delete-filled-blue');
    }

    private addSvgIcon(name: string): void {
        this.matIconRegistry.addSvgIcon(
            name,
            this.domSanitizer.bypassSecurityTrustResourceUrl(`/assets/icons/${name}.svg`),
        );
    }

    closeDialog(): void {
        this.dialogRef.close(false);
    }

    onTryItOutClick(): void {
        this.mixpanelService.track(MIXPANEL_EVENTS.COMPANY_VALUATION_TRY_OUT_ANNOUNCEMENT_BUTTON_CLICK);
        this.dialogRef.close(true);
    }
}
